///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import AutoComplete from "../../form-controls/AutoComplete";
import { getEmployees } from "../../../api/persons";
import messages from "../../../helpers/messages";

export const TeamMemberAssignment = ({
  teamMember,
  label,
  field,
  dataTestId,
  showRemoveIcon,
  disabled,
  onChange,
  onRemove
}) => {
  const value = teamMember.userId
    ? {
        label: teamMember.fullName,
        value: teamMember.userId
      }
    : null;

  return (
    <>
      <div
        className="grid__cell one-whole pb-16 pos-relative"
        data-testid={dataTestId}
      >
        <AutoComplete
          value={value}
          handleOptionsMapping={options =>
            options.map(option => ({
              ...option,
              label: option.fullName,
              value: option.userId
            }))
          }
          fetchFrom={getEmployees}
          label={label}
          handleChange={selected =>
            onChange(selected, teamMember.id ? teamMember : value, field)
          }
          isDisabled={disabled}
          error={teamMember.error}
          validationMessage={
            messages.thisUserHasAlreadyBeenSelected.defaultMessage
          }
        />
        {showRemoveIcon && (
          <button className="remove-user fr pr-8" onClick={onRemove}>
            {messages.remove.defaultMessage}
          </button>
        )}
      </div>
    </>
  );
};

export default TeamMemberAssignment;
